<template>
  <popup ref="popup" :loading="popupLoading" :appendToBody="true">
    <div slot="body" class="tab-body">
      <div></div>
      <div class="dataTable autoFlex" v-if="listData">
        <el-table
          class="table"
          :data="listData"
          align="center"
          :header-cell-style="{ 'text-align': 'center' }"
          height="auto"
          v-loading="listLoading"
        >
         <el-table-column width="45px" prop="name" label="No">
             <template slot-scope="scope">
                 {{scope.$index+1}}
            </template>
          </el-table-column>

          <el-table-column width="65px" prop="name" label="姓名">
          </el-table-column>
          <el-table-column width="65px" prop="post" label="岗位">
            <template slot-scope="scope">
              <el-tag type="danger" size="mini" v-if="scope.row.post == '前端'"
                >前端</el-tag
              >
              <el-tag type="warning" size="mini" v-if="scope.row.post == '后端'"
                >后端</el-tag
              >
              <el-tag size="mini" v-if="scope.row.post == '测试'">测试</el-tag>
            </template></el-table-column
          >
          <el-table-column
            width="95px"
            prop="interviewtime"
            label="上门时间"
          ></el-table-column>
          <el-table-column
            width="95px"
            prop="invitetime"
            label="邀约时间"
          ></el-table-column>
          <el-table-column width="65px" prop="dyer" label="电邀">
            <template slot-scope="scope">
              {{ scope.row.dyer }}
            </template>
          </el-table-column>
          <el-table-column width="65px" prop="zxer" label="咨询">
            <template slot-scope="scope">
              {{ scope.row.zxer }}
            </template>
          </el-table-column>
          <el-table-column width="65px" prop="jser" label="技术">
            <template slot-scope="scope">
              {{ scope.row.jser }}
            </template>
          </el-table-column>
          <el-table-column width="65px" prop="rank" label="评级">
            <template slot-scope="scope">
              <el-tag type="danger" size="mini" v-if="scope.row.rank == 1"
                >D量</el-tag
              >
              <el-tag type="warning" size="mini" v-if="scope.row.rank == 2"
                >C量</el-tag
              >
              <el-tag size="mini" v-if="scope.row.rank == 3">B量</el-tag>
              <el-tag type="success" size="mini" v-if="scope.row.rank == 4"
                >A量</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="state"
            label="状态"
            align="center"
            width="140px"
          ></el-table-column>
           <el-table-column
            prop="recruid"
            label="平台"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" fixed="right"  >
            <template slot-scope="scope">
              <div class="dataTable-operator">
                <el-button
                  v-has-permission-code-and="'100000150005'"
                  size="mini"
                  type="text"
                  @click="toDetail(scope.$index)"
                  >详情</el-button
                >
                <el-button
                  type="text"
                  v-has-permission-code-and="'100000150025'"
                  @click="attackTo(scope.$index)"
                  size="mini"
                  >跟进</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="close">关闭{{title}}</el-button>
      </div>
      <show ref="show" @flush="list()"></show>
      <attckone ref="attckone" @flush="list()"></attckone>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultation/consultation.js";
import show from "@/views/consu/consultation/show.vue";
import attckone from "@/views/consu/consultation/attackone.vue";


export default {
  name: "dailydylist",
  components: {
    popup,
    show,
    attckone
  },
  data() {
    return {
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      listData: [],
      listLoading: false,
      title: "",
    };
  },
  methods: {
    //打开弹框
    open(parameter, title) {
      this.parameter = parameter;
      this.title = title;

      this.listLoading = true;

      this.$refs.popup.open(title, "75%");

      this.$nextTick(() => {
        api.list2Day(this.parameter, (response) => {
          this.listData = response.data;
          this.listLoading = false;
        });
      });
    },
    toDetail( index) {
      
      this.$refs.show.open(index,  this.listData ,"详情",'70%');
    },  attackTo(index) {

        this.$refs.attckone.open(index,  this.listData , "完成跟进", false,'70%');
    
    },
    //关闭弹框
    close() {
      this.$refs.popup.close();
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
